import type { IKVStorage } from '@monofe/util';

export enum UserCookieStateValue {
    Unset = 0,
    Accepted = 1,
    Declined = 2,
}

const KEY_UserDownloadRequestState = 'UserCookieState';

const _GetKey = <T extends number | string>(
    storage: IKVStorage,
    key: string,
    fallback: T,
): Promise<T> =>
    new Promise<T>((resolve, reject) => {
        storage
            .getItem(key)
            .then(result => {
                resolve((result as T) ?? fallback);
            })
            .catch((error: Error) => {
                reject(error);
            });
    });

const _SetKey = <T extends number | string>(
    storage: IKVStorage,
    key: string,
    value: T,
): Promise<void> =>
    new Promise<void>((resolve, reject) => {
        storage
            .setItem(key, value)
            .then(() => {
                resolve();
            })
            .catch((error: Error) => {
                reject(error);
            });
    });

const UserCookieState = (storage: IKVStorage) =>
    _GetKey<UserCookieStateValue>(
        storage,
        KEY_UserDownloadRequestState,
        UserCookieStateValue.Unset,
    );

const SetUserCookieState = (storage: IKVStorage, newVal: UserCookieStateValue) =>
    _SetKey<UserCookieStateValue>(storage, KEY_UserDownloadRequestState, newVal);

const module = {
    UserCookieState,
    SetUserCookieState,
};

export default module;
